import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardHeader } from '../../../../components/card/card';
import Select from 'react-select';

import {
  deletePayElementEntry,
  GetElementEntryToAdd
} from '../../../../store/HR/Payroll/payrollElementEntrySlice';
import { AddPayrollElementEntrySchema } from '../../../ValidationForm/validationSchema';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import useGetPeriodTimeByPayroll from '@hooks/Payrolls/useGetPeriodTimeByPayroll';
import NtxTable from '@components/DataTable/NtxTable';
import showConfirmation from '@components/Shared/Alert/Confirmation';

function List({ list, period }) {
  const { assignmentId, payrollId } = useParams();

  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Elemente'), key: 'Name' },
    { title: t('Value'), key: 'Value' },
    { title: t('Start Date'), key: 'Start' },
    { title: t('Date_TO'), key: 'End' },

    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const sortedList = [...(list || [])]?.sort((a, b) => {
    // الراتب الاساسي يظهر دائما في الأول
    // إذا كان العنصر هو المطلوب (7835...)، يظهر أولاً
    if (a.elementTypeId === '7835f737-e11c-48b5-9fb9-1eb465a431ff') return -1;
    if (b.elementTypeId === '7835f737-e11c-48b5-9fb9-1eb465a431ff') return 1;
    // وبقية العناصر تظهر بالترتيب الطبيعي
    return 0;
  });

  const tableData = sortedList?.map(item => {
    // let rowClass;

    let name = i18n.language === 'en' ? item.elementTypeName : item.elementTypeName2;

    const hideButton =
      item.elementTypeId === '7835f737-e11c-48b5-9fb9-1eb465a431ff' || period.hasRun;

    return {
      Name: (
        <div className='d-flex flex-column'>
          <div className=''>{name}</div>

          <div className='d-flex  align-items-center mt-1'>
            <span className='badge bg-info text-white me-2'>{item.uom}</span>
            {item.isRecurring ? (
              <span className='badge bg-success text-white'>دوري</span>
            ) : (
              <span className='badge bg-secondary text-white'>غير دوري</span>
            )}
          </div>
        </div>
      ),
      Value: item.screenEntryValue,
      Start: item.startDate,
      End: item.isRecurring ? (
        <span className='badge bg-warning text-dark fa-lg'>
          <i className='fas fa-infinity me-1'></i>
          مستمر
        </span>
      ) : (
        item.endDate
      ),
      action: !hideButton && ( // إذا كان isDel = false يعرض الزر، وإلا يخفيها
        <button
          type='button'
          className='btn btn-sm btn-outline-danger'
          onClick={() => handleDelete(item)}
        >
          <i className='fas fa-lg fa-fw fa-trash'></i>
        </button>
      )
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const handleDelete = async item => {
    const message =
      i18n.language === 'ar'
        ? `هل أنت متأكد من حذف العنصر (${item.elementTypeName2})؟`
        : `Are you sure you want to delete the item ( ${item.elementTypeName})?`;

    showConfirmation(message, async () => {
      const res = await dispatch(deletePayElementEntry(item.elementEntryId)).unwrap();
      debugger;
      if (res === true) {
        CustomAlert({ action: 'Add', msg: 'تمت العملـية بنجـاح' });
        dispatch(
          GetElementEntryToAdd({
            periodId: period.value,
            assignmentId: assignmentId
          })
        );
      } else {
        CustomAlert({ action: 'Error' });
      }
    });
  };

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table text-nowrap table-hover '
        // enableSearch
        // showRecordsSelector
      />
    </>
  );
}

export default List;
